module.exports = require("rxjs/add/observable/concat");